import { Directive, Input, ElementRef, Renderer2, HostListener } from '@angular/core';
import { UtilityService } from '../service/utility.service';
import { Sort } from '../util/sort';

@Directive({
  selector: '[appSort]'
})
export class SortDirective {
  @Input() appSort: Array<any>;
  constructor(private renderer: Renderer2, private targetElem: ElementRef, private utility:UtilityService) { }
  @HostListener("click")
  sortData() {
    // Create Object of Sort Class
    const sort = new Sort();
    // Get Reference Of Current Clicked Element
    const elem = this.targetElem.nativeElement;
    // Get In WHich Order list should be sorted by default it should be set to desc on element attribute
    const order = elem.getAttribute("data-order");
    // Get The Property Type specially set [data-type=date] if it is date field
    const type = elem.getAttribute("data-type");
    // Get The Property Name from Element Attribute
    const property = elem.getAttribute("data-name");
    const sortColumn = {column:property,direction:order}
    if (order === "desc") {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "asc");
      sortColumn['direction'] = 'asc';
    }
    else {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "desc");
      sortColumn['direction'] = 'desc';
    }

    this.utility.sortColumn = sortColumn;
    // console.log("sortColumn ======> ",sortColumn)
  }

}
